import { render } from "./managePermission.vue?vue&type=template&id=831cfdae"
import script from "./managePermission.vue?vue&type=script&lang=js"
export * from "./managePermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__